export default __webpack_public_path__ + "static/media/active.f5f1388c.svg";